module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-betp-up@2x.png?0.0.53";